import { render } from "./InterviewPage.vue?vue&type=template&id=6494bac5"
import script from "./InterviewPage.vue?vue&type=script&lang=js"
export * from "./InterviewPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__